export const CASUAL_PAGE_CONFIG = {
  "title": "Realtime IAA Revenue",
  "titleCN": "休闲游戏实时收入",
  "subTitle": "Timezone (UTC{{timeZone}})",
  "subTitleCN": "时区 (UTC{{timeZone}})",
  "path": "/realtime/iaaRevenue",
  "defaultTab": "overview",
  "tabList": [
    {
      "id": "overview",
      "tabName": "Overview",
      "tabNameCN": "总览",
      "isHaveNotification": true,
      "refresh": true,
      "notificationPath": "/realtime/iaaRevenue/overview",
      "path": "/realtime/iaaRevenue",
      "tabIcon": "",
      "logConfig": {
        "pageId": "207001",
        "pageName": "Realtime IAA Revenue",
        "extInfo": "Realtime IAA Revenue Overview",
        "pagePath": "/realtime/iaaRevenue"
      },
      "filters": [
        {
          "name": "RealtimeRevenueFilter",
          "isOpenSticky": false,
          "isHaveFilterSave": true,
          "filterPath": "/realtime/iaaRevenue",
          "selectorApi": "/api/v1/dashboard/pc/realtime/ua/selector",
          "extraSelectorParams": {
            "system": "bi_realtime_monetization_m",
            "data_source": "dashboard"
          },
          "componentList": [
            {
              "name": "MetricInfo",
              "children": [
                {
                  "name": "MetricsCardTitle",
                  "className": "",
                  "type": "view",
                  "style": {},
                  "props": {
                    "config": {
                      "titleEn": "Realtime Key Metrics",
                      "titleCn": "实时关键指标",
                      "isMetricsExplain": false
                    }
                  }
                },
                {
                  "name": "CommonRow",
                  "children": [
                    {
                      "name": "CommonCol",
                      "type": "layout",
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "realtimeUserService",
                          "className": "dbd-daily-card",
                          "type": "view",
                          "data": {
                            "height": 164
                          },
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/pc/realtime/ua/card",
                              "dataKey": "iaa_revenue",
                              "refreshKey": "realtime_iaa_revenue",
                              "interval": 300000,
                              "isByDimensionCard": true,
                              "extraParams": {
                                "metrics": [
                                  "iaa_revenue"
                                ],
                                "accumulation": {
                                  "custom_accumulation": [
                                    {
                                      "key": "ad_format",
                                      "is_accumulation": true
                                    }
                                  ]
                                }
                              }
                            }
                          },
                          "children": [
                            {
                              "name": "MetricCardCo",
                              "className": "dbd-retention-card",
                              "type": "view",
                              "style": {
                                "marginTop": "0",
                                "minHeight": "179px"
                              },
                              "props": {
                                "config": {
                                  "apiDataKey": "iaa_revenue"
                                }
                              },
                              "children": [
                                {
                                  "name": "MetricComponent",
                                  "path": "realtime/revenue",
                                  "componentKey": "IAARevenuePlatformCard",
                                  "height": 179,
                                  "config": {
                                    "props": {
                                      "dimension": "ad_format",
                                      "isRealTime": true,
                                      "hasChart": false,
                                      "config": {
                                        "dataKey": "{{iaa_revenue.data}}"
                                      },
                                      "style": {
                                        "minHeight": "179px"
                                      }
                                    }
                                  }
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "type": "layout",
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "realtimeUserService",
                          "className": "dbd-daily-card",
                          "type": "view",
                          "data": {
                            "height": 164
                          },
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/pc/realtime/ua/card",
                              "dataKey": "ecpm",
                              "refreshKey": "realtime_ecpm",
                              "interval": 300000,
                              "isByDimensionCard": true,
                              "extraParams": {
                                "metrics": [
                                  "ecpm"
                                ],
                                "accumulation": {
                                  "custom_accumulation": [
                                    {
                                      "key": "ad_format",
                                      "is_accumulation": true
                                    }
                                  ]
                                }
                              }
                            }
                          },
                          "children": [
                            {
                              "name": "MetricCardCo",
                              "className": "dbd-retention-card",
                              "type": "view",
                              "style": {
                                "marginTop": "0",
                                "minHeight": "179px"
                              },
                              "props": {
                                "config": {
                                  "apiDataKey": "ecpm"
                                }
                              },
                              "children": [
                                {
                                  "name": "MetricComponent",
                                  "path": "realtime/revenue",
                                  "componentKey": "EcpmPlatformCard",
                                  "height": 179,
                                  "config": {
                                    "props": {
                                      "dimension": "ad_format",
                                      "hasChart": false,
                                      "isRealTime": true,
                                      "config": {
                                        "dataKey": "{{ecpm.data}}"
                                      },
                                      "style": {
                                        "minHeight": "179px"
                                      }
                                    }
                                  }
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "CommonRow",
                  "className": "margin-t-10",
                  "children": [
                    {
                      "name": "CommonCol",
                      "type": "layout",
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "realtimeUserService",
                          "className": "dbd-daily-card",
                          "type": "view",
                          "data": {
                            "height": 164
                          },
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/pc/realtime/ua/card",
                              "dataKey": "iaa_impressions",
                              "refreshKey": "realtime_iaa_impressions",
                              "interval": 300000,
                              "isByDimensionCard": true,
                              "extraParams": {
                                "metrics": [
                                  "iaa_impressions"
                                ],
                                "accumulation": {
                                  "custom_accumulation": [
                                    {
                                      "key": "ad_format",
                                      "is_accumulation": true
                                    }
                                  ]
                                }
                              }
                            }
                          },
                          "children": [
                            {
                              "name": "MetricCardCo",
                              "className": "dbd-retention-card",
                              "type": "view",
                              "style": {
                                "marginTop": "0",
                                "minHeight": "179px"
                              },
                              "props": {
                                "config": {
                                  "apiDataKey": "iaa_impressions"
                                }
                              },
                              "children": [
                                {
                                  "name": "MetricComponent",
                                  "path": "realtime/revenue",
                                  "componentKey": "ImpressionsPlatformCard",
                                  "height": 179,
                                  "config": {
                                    "props": {
                                      "dimension": "ad_format",
                                      "hasChart": false,
                                      "isRealTime": true,
                                      "config": {
                                        "dataKey": "{{iaa_impressions.data}}"
                                      },
                                      "style": {
                                        "minHeight": "179px"
                                      }
                                    }
                                  }
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "type": "layout",
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "realtimeUserService",
                          "className": "dbd-daily-card",
                          "type": "view",
                          "data": {
                            "height": 164
                          },
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/pc/realtime/ua/card",
                              "dataKey": "iaa_fill_rate_per",
                              "refreshKey": "realtime_iaa_fill_rate_per",
                              "interval": 300000,
                              "isByDimensionCard": true,
                              "extraParams": {
                                "metrics": [
                                  "iaa_fill_rate_per"
                                ],
                                "accumulation": {
                                  "custom_accumulation": [
                                    {
                                      "key": "ad_format",
                                      "is_accumulation": true
                                    }
                                  ]
                                }
                              }
                            }
                          },
                          "children": [
                            {
                              "name": "MetricCardCo",
                              "className": "dbd-retention-card",
                              "type": "view",
                              "style": {
                                "marginTop": "0",
                                "minHeight": "179px"
                              },
                              "props": {
                                "config": {
                                  "apiDataKey": "iaa_fill_rate_per"
                                }
                              },
                              "children": [
                                {
                                  "name": "MetricComponent",
                                  "path": "realtime/revenue",
                                  "componentKey": "FillRatePlatformCard",
                                  "height": 179,
                                  "config": {
                                    "props": {
                                      "dimension": "ad_format",
                                      "isRealTime": true,
                                      "hasChart": false,
                                      "showShare": false,
                                      "config": {
                                        "dataKey": "{{iaa_fill_rate_per.data}}"
                                      },
                                      "style": {
                                        "minHeight": "179px"
                                      }
                                    }
                                  }
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "realtimeUserService",
                  "className": "",
                  "type": "view",
                  "style": {},
                  "props": {
                    "config": {
                      "api": "/api/v1/dashboard/event_analysis/realtime/date_event_list",
                      "": true,
                      "dataKey": "date_event_list",
                      "refreshKey": "realtime_user_event",
                      "interval": 300000
                    }
                  },
                  "children": [
                    {
                      "name": "SegmentScrollCo",
                      "className": "margin-t-20",
                      "style": {},
                      "type": "view",
                      "props": {
                        "config": {
                          "componentSegment": [
                            {
                              "value": "1",
                              "enName": "{{metricsInfo.iaa_revenue.en}}",
                              "cnName": "{{metricsInfo.iaa_revenue.cn}}"
                            },
                            {
                              "value": "2",
                              "enName": "{{metricsInfo.iaa_impressions.en}}",
                              "cnName": "{{metricsInfo.iaa_impressions.cn}}"
                            },
                            {
                              "value": "3",
                              "enName": "{{metricsInfo.ecpm.en}}",
                              "cnName": "{{metricsInfo.ecpm.cn}}"
                            },
                            {
                              "value": "4",
                              "enName": "{{metricsInfo.fill_rate.en}}",
                              "cnName": "{{metricsInfo.fill_rate.cn}}"
                            }
                          ],
                          "scrollMarginTop": "75px"
                        }
                      },
                      "children": [
                        {
                          "name": "realtimeUserService",
                          "className": "",
                          "type": "view",
                          "style": {
                            "scrollMarginTop": "75px"
                          },
                          "id": 1,
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/pc/realtime/ua/trend",
                              "dataKey": "iaa_revenue",
                              "refreshKey": "realtime_iaa_revenue",
                              "interval": 300000,
                              "extraParams": {
                                "metrics": [
                                  "iaa_revenue"
                                ]
                              }
                            }
                          },
                          "children": [
                            {
                              "name": "MetricComponent",
                              "path": "realtime/revenue",
                              "componentKey": "IaaRevenueRealtimeCard",
                              "config": {}
                            }
                          ]
                        },
                        {
                          "name": "realtimeUserService",
                          "className": "",
                          "type": "view",
                          "style": {
                            "scrollMarginTop": "75px"
                          },
                          "id": 2,
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/pc/realtime/ua/trend",
                              "dataKey": "iaa_impressions",
                              "refreshKey": "realtime_iaa_impressions",
                              "interval": 300000,
                              "extraParams": {
                                "metrics": [
                                  "iaa_impressions"
                                ]
                              }
                            }
                          },
                          "children": [
                            {
                              "name": "MetricComponent",
                              "path": "realtime/revenue",
                              "componentKey": "IaaResponsesRealtimeCard",
                              "config": {}
                            }
                          ]
                        },
                        {
                          "name": "realtimeUserService",
                          "className": "",
                          "type": "view",
                          "style": {
                            "scrollMarginTop": "75px"
                          },
                          "id": 3,
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/pc/realtime/ua/trend",
                              "dataKey": "ecpm",
                              "refreshKey": "realtime_ecpm",
                              "interval": 300000,
                              "extraParams": {
                                "metrics": [
                                  "ecpm"
                                ]
                              }
                            }
                          },
                          "children": [
                            {
                              "name": "MetricComponent",
                              "path": "realtime/revenue",
                              "componentKey": "EcpmRealtimeCard",
                              "config": {}
                            }
                          ]
                        },
                        {
                          "name": "realtimeUserService",
                          "className": "",
                          "type": "view",
                          "style": {
                            "scrollMarginTop": "75px"
                          },
                          "id": 4,
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/pc/realtime/ua/trend",
                              "dataKey": "iaa_fill_rate_per",
                              "refreshKey": "realtime_iaa_fill_rate_per",
                              "interval": 300000,
                              "extraParams": {
                                "interval": 60,
                                "metrics": [
                                  "iaa_fill_rate_per"
                                ]
                              }
                            }
                          },
                          "children": [
                            {
                              "name": "MetricComponent",
                              "path": "realtime/revenue",
                              "componentKey": "FillRateRealtimeCard",
                              "config": {}
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "id": "byPlatformRegionAdFormat",
      "tabName": "By Platform/Region/Ad Format",
      "tabNameCN": "分平台/地区/广告类型",
      "isHaveNotification": true,
      "refresh": true,
      "notificationPath": "/realtime/iaaRevenue/byPlatformRegionAdFormat",
      "path": "/realtime/iaaRevenue/byPlatformRegionAdFormat",
      "tabIcon": "",
      "logConfig": {
        "pageId": "207101",
        "pageName": "Realtime IAA Revenue",
        "extInfo": "Realtime IAA Revenue By Platform Region AdFormat",
        "pagePath": "/realtime/iaaRevenue/byPlatformRegionAdFormat"
      },
      "filters": [
        {
          "name": "realtimeCountryFilter",
          "isOpenSticky": false,
          "isHaveFilterSave": true,
          "filterPath": "/realtime/iaaRevenue/byPlatformRegionAdFormat",
          "selectorApi": "/api/v1/dashboard/pc/realtime/ua/selector",
          "extraSelectorParams": {
            "system": "bi_realtime_monetization_m",
            "data_source": "dashboard"
          },
          "componentList": [
            {
              "name": "MetricInfo",
              "children": [
                {
                  "name": "realtimeUserService",
                  "className": "dbd-daily-card",
                  "type": "view",
                  "style": {},
                  "props": {
                    "config": {
                      "api": "/api/v1/dashboard/pc/realtime/ua/dimension/trend",
                      "dataKey": "country_iaa_revenue",
                      "refreshKey": "realtime_country_iaa_revenue",
                      "interval": 300000,
                      "extraParams": {
                        "metrics": [
                          "iaa_revenue"
                        ]
                      }
                    }
                  },
                  "data": {
                    "dataBy": "ad_format"
                  },
                  "children": [
                    {
                      "name": "realtimeUserService",
                      "className": "dbd-daily-card",
                      "type": "view",
                      "style": {},
                      "props": {
                        "config": {
                          "api": "/api/v1/dashboard/pc/realtime/ua/dimension/trend",
                          "dataKey": "country_ecpm",
                          "refreshKey": "realtime_country_ecpm",
                          "interval": 300000,
                          "extraParams": {
                            "metrics": [
                              "ecpm"
                            ]
                          }
                        }
                      },
                      "children": [
                        {
                          "name": "realtimeUserService",
                          "className": "dbd-daily-card",
                          "type": "view",
                          "style": {},
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/pc/realtime/ua/dimension/trend",
                              "dataKey": "country_iaa_impressions",
                              "refreshKey": "realtime_country_iaa_impressions",
                              "interval": 300000,
                              "extraParams": {
                                "metrics": [
                                  "iaa_impressions"
                                ]
                              }
                            }
                          },
                          "children": [
                            {
                              "name": "realtimeUserService",
                              "className": "dbd-daily-card",
                              "type": "view",
                              "style": {},
                              "props": {
                                "config": {
                                  "api": "/api/v1/dashboard/pc/realtime/ua/dimension/trend",
                                  "dataKey": "country_iaa_fill_rate_per",
                                  "refreshKey": "realtime_country_iaa_fill_rate_per",
                                  "interval": 300000,
                                  "extraParams": {
                                    "interval": 60,
                                    "metrics": [
                                      "iaa_fill_rate_per"
                                    ]
                                  }
                                }
                              },
                              "children": [
                                {
                                  "name": "realtimeUserService",
                                  "className": "dbd-daily-card",
                                  "type": "view",
                                  "style": {},
                                  "props": {
                                    "config": {
                                      "api": "/api/v1/dashboard/pc/realtime/ua/dimension/trend",
                                      "dataKey": "country_iaa_display_rate_per",
                                      "refreshKey": "realtime_country_iaa_display_rate_per",
                                      "interval": 300000,
                                      "extraParams": {
                                        "metrics": [
                                          "iaa_display_rate_per"
                                        ]
                                      },
                                      "formatData": "function(data) {\n                                                                                if (!(data === null || data === void 0 ? void 0 : data.iaa_display_rate_per)) return data;\n                                                                                var filterBanner = function(arr, key) {\n                                                                                    return Array.isArray(arr) ? arr.filter(function(item) {\n                                                                                        return ((item === null || item === void 0 ? void 0 : item[key]) || '').toLowerCase() !== 'banner';\n                                                                                    }) : arr;\n                                                                                };\n                                                                                var result = Object.assign({}, data, {\n                                                                                    iaa_display_rate_per: Object.assign({}, data.iaa_display_rate_per, {\n                                                                                        list: filterBanner(data.iaa_display_rate_per.list, 'type'),\n                                                                                        top: filterBanner(data.iaa_display_rate_per.top, 'name'),\n                                                                                        info: filterBanner(data.iaa_display_rate_per.info, 'name')\n                                                                                    })\n                                                                                });\n                                                                                return result;\n                                                                            }"
                                    }
                                  },
                                  "children": [
                                    {
                                      "name": "ScrollBodyCo",
                                      "className": "margin-t-20",
                                      "style": {},
                                      "type": "view",
                                      "props": {
                                        "config": {
                                          "dataKey": "dataBy",
                                          "componentSegment": [
                                            {
                                              "value": "1",
                                              "enName": "{{metricsInfo.iaa_revenue.en}}",
                                              "cnName": "{{metricsInfo.iaa_revenue.cn}}"
                                            },
                                            {
                                              "value": "2",
                                              "enName": "{{metricsInfo.iaa_impressions.en}}",
                                              "cnName": "{{metricsInfo.iaa_impressions.cn}}"
                                            },
                                            {
                                              "value": "3",
                                              "enName": "{{metricsInfo.ecpm.en}}",
                                              "cnName": "{{metricsInfo.ecpm.cn}}"
                                            },
                                            {
                                              "value": "4",
                                              "enName": "{{metricsInfo.fill_rate.en}}",
                                              "cnName": "{{metricsInfo.fill_rate.cn}}"
                                            },
                                            {
                                              "value": "5",
                                              "enName": "{{metricsInfo.display_rate.en}}",
                                              "cnName": "{{metricsInfo.display_rate.cn}}"
                                            }
                                          ],
                                          "scrollMarginTop": "75px"
                                        }
                                      },
                                      "children": [
                                        {
                                          "name": "MetricComponent",
                                          "path": "realtime/revenue",
                                          "componentKey": "IaaRevenueByDimensionCard",
                                          "id": 1,
                                          "config": {}
                                        },
                                        {
                                          "name": "MetricComponent",
                                          "path": "realtime/revenue",
                                          "componentKey": "IaaResponsesByDimensionCard",
                                          "id": 2,
                                          "config": {}
                                        },
                                        {
                                          "name": "MetricComponent",
                                          "path": "realtime/revenue",
                                          "componentKey": "EcpmByDimensionCard",
                                          "id": 3,
                                          "config": {}
                                        },
                                        {
                                          "name": "MetricComponent",
                                          "path": "realtime/revenue",
                                          "componentKey": "FillRateByDimensionCard",
                                          "id": 4,
                                          "config": {}
                                        },
                                        {
                                          "name": "MetricComponent",
                                          "path": "realtime/revenue",
                                          "componentKey": "DisplayByDimensionCard",
                                          "id": 5,
                                          "config": {}
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};